import { Component, forwardRef, inject, Injector, Input, ViewChild } from '@angular/core';
import {
  ControlContainer,
  ControlValueAccessor,
  FormControl,
  FormControlDirective,
  FormGroup,
  NG_VALUE_ACCESSOR
} from '@angular/forms';

@Component({
  standalone: true,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CustomFormControlComponent),
      multi: true
    }
  ],
  template: ''
})
export abstract class CustomFormControlComponent implements ControlValueAccessor {
  @Input() formControl: FormControl;
  @Input() formControlName: string;
  @ViewChild(FormControlDirective, { static: true })
  formControlDirective: FormControlDirective;

  injector = inject(Injector);

  writeValue(value: any): void {
    this.formControlDirective?.valueAccessor.writeValue(value);
  }

  registerOnChange(fn: any): void {
    this.formControlDirective?.valueAccessor.registerOnChange(fn);
  }

  registerOnTouched(fn: any): void {
    this.formControlDirective?.valueAccessor.registerOnTouched(fn);
  }

  setDisabledState(isDisabled: boolean): void {
    this.formControlDirective?.valueAccessor.setDisabledState(isDisabled);
  }

  get control(): FormControl {
    return (this.formControl ?? this.formGroup.get(this.formControlName)) as FormControl;
  }

  get formGroup(): FormGroup {
    return this.injector.get(ControlContainer)?.control as FormGroup;
  }
}
